<template>
  <div class="History-container">
    <SectionTop :id="2" />
    <div class="history-bg"></div>
    <PostLiist :limit="3" />
    <ViewMore :id="2" customClass="view-more-wrapper-history" />
  </div>
</template>

<script>
import SectionTop from '@/features/home/components/SectionTop.vue';
import PostLiist from '@/features/common/PostList.vue';
import ViewMore from '@/features/home/components/ViewMore.vue';

export default {
  components: {
    SectionTop,
    PostLiist,
    ViewMore,
  }
};
</script>

<style scoped>
.History-container {
  position: relative;
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  gap: 40px;
  margin-bottom: 0px;
}

.history-bg {
  position: absolute;
  top: 40%;
  width: 480px;
  height: 440px;
  border-radius: 15rem;
  background: linear-gradient(197.37deg, #7550db34 -0.38%, rgba(138, 234, 240, 0) 101.89%), linear-gradient(115.93deg, #3e88f672 4.86%, rgba(62, 180, 246, 0.33) 38.05%, rgba(62, 235, 246, 0) 74.14%), radial-gradient(56.47% 76.87% at 6.92% 7.55%, rgba(62, 209, 246, 0.258) 0%, rgba(62, 158, 246, 0.182) 52.16%, rgba(62, 246, 246, 0) 100%), linear-gradient(306.53deg, #2ee4e45b 19.83%, rgba(46, 228, 227, 0) 97.33%);
  background-blend-mode: screen, color-dodge, darken, overlay, luminosity, color;
  filter: blur(50px);
  opacity: 0.1;
}

.view-more-wrapper-history {
  margin-top: -50px;
}

@media screen and (max-width: 570px) {
  .view-more-wrapper-history {
    transform: translateY(-20px);
  }
}
</style>